import { FunctionalComponent, h } from "@stencil/core";

export const LogoutIcon: FunctionalComponent = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M10.8089 2C13.4627 3.02774 15.3516 5.67149 15.3516 8.77097C15.3516 12.7635 12.2175 16 8.35151 16C4.48558 16 1.35156 12.7635 1.35156 8.77097C1.35156 5.6771 3.23364 3.03716 5.87979 2.00561"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.35072 1V6"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
